import React from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllPencairan } from "stores/Pengajuan/function";
import PencairanMonitoring from "./PencairanMonitoring";

const pageSizeOptions = [
  { value: 10, label: "10" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

export default function Pencairan() {
  const dispatch = useDispatch();
  const result = useSelector((state) => state.pengajuanReducer.listPencairan);
  const [searchText, setSearchText] = React.useState("");
  const [query, setQuery] = React.useState({ search: "" });
  const [pending, setPending] = React.useState(true);
  const [error, setError] = React.useState("");
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [detail, setDetail] = React.useState(null);
  const rows = Array.isArray(result?.data) ? result.data : [];
  const serverPageCount = Number(result?.totalPages);
  const pageCount = Number.isFinite(serverPageCount)
    ? Math.max(0, Math.floor(serverPageCount))
    : 0;

  const handleApply = () => {
    setPage(0);
    setQuery({ search: searchText.trim() });
  };

  const handleReset = () => {
    setSearchText("");
    setPage(0);
    setQuery({ search: "" });
  };

  const handlePageSizeChange = (option) => {
    setTotalPerHalaman(option.value);
    setPage(0);
  };

  React.useEffect(() => {
    let active = true;
    setPending(true);
    setError("");
    getAllPencairan(dispatch, {
      status: "Disetujui",
      cari: query.search,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((status) => {
        if (status !== 200) throw new Error("Gagal memuat pencairan");
      })
      .catch(() => {
        if (active) setError("Data pencairan belum dapat dimuat. Silakan coba lagi.");
      })
      .finally(() => {
        if (active) setPending(false);
      });
    return () => { active = false; };
  }, [dispatch, page, totalPerHalaman, query]);

  React.useEffect(() => {
    if (!pending && !error && page > Math.max(0, pageCount - 1)) {
      setPage(Math.max(0, pageCount - 1));
    }
  }, [pending, error, page, pageCount]);

  return (
    <Container fluid className="pencairan-page">
      <PencairanMonitoring
        rows={rows}
        pending={pending}
        error={error}
        search={searchText}
        appliedSearch={query.search}
        onSearch={(event) => setSearchText(event.target.value)}
        onApply={handleApply}
        onReset={handleReset}
        onRefresh={() => setQuery({ ...query })}
        page={page}
        pageCount={pageCount}
        pageSize={totalPerHalaman}
        pageSizeOptions={pageSizeOptions}
        onPageChange={setPage}
        onPageSizeChange={handlePageSizeChange}
        detail={detail}
        onDetail={setDetail}
        onCloseDetail={() => setDetail(null)}
      />
    </Container>
  );
}
